import { Tabs as PDCTabs } from "@mzc-pdc/ui";
import { alpha, styled } from "@mui/material";

export const StyledTabs = styled(PDCTabs)(({ theme, type, orientation, divider, sx }) => ({
    ".MuiTabs-flexContainer": {
        ...sx,
        "&:before": {
            content: '""',
            position: `absolute`,
            left: 0,
            bottom: 0,
            right: 0,
        },
    },
    ".MuiButtonBase-root.MuiTab-root": {
        fontSize: theme.typography.body1_500,
    },
    ...(orientation === "vertical" && {
        "& .MuiTabs-indicator": {
            width: `4px`,
            left: `0`,
            backgroundColor: theme.palette.primary.main,
        },
        "& .MuiTab-root": {
            border: `none`,
            minHeight: `40px`,
            alignItems: `baseline`,
            padding: `0 16px`,
            borderRadius: `3px`,
            fontWeight: `500`,
            "& + &": {
                marginTop: `8px`,
            },
            "&:hover": {
                backgroundColor: alpha(theme.palette.greySecondary[50], 0.5),
            },
            "&.Mui-selected": {
                color: theme.palette.primary.main,
                backgroundColor: alpha(theme.palette.greySecondary[50], 0.5),
                "&:hover": {
                    backgroundColor: alpha(theme.palette.greySecondary[50], 0.8),
                },
            },
        },
    }),
    // 맨 앞 탭 왼쪽은 구분할 대상이 없다. PDC Tabs 가 사방에 주는 보더 중 왼쪽만 덜어낸다.
    // (Figma 디자인 시스템 Tabs 규칙 — 첫 번째 탭은 border 가 빠진다)
    // 🔴 filled 는 제외한다 — 세그먼트 컨트롤이라 왼쪽 가장자리 선이 형태의 일부다.
    //    빼면 왼쪽 모서리만 둥글고 선이 없어 한쪽이 터져 보인다(아래 filled 분기의 borderRadius 참고).
    // ⚠️ PDC `Tabs` 에는 이 콘솔의 `type="filled"` 와 **별개로** 자체 `isFilled` prop 이 있고,
    //    그쪽도 세그먼트 형태를 그린다. 이 가드는 그걸 못 잡는다.
    //    지금은 사용처가 0 곳이라 살아 있는 회귀가 아니지만, 누가 `isFilled` 를 직접 쓰면 같은 버그가 재발한다.
    // 🔴 `border-left: none` 이 아니라 색만 투명하게 한다.
    //    none 으로 지우면 보더가 차지하던 1px 만큼 박스가 줄어 라벨이 통째로 1px 앞당겨지고,
    //    첫 탭만 좌우 여백이 20/21 로 어긋난다(실측). 자리는 남기고 선만 감춰야 가운데 정렬이 유지된다.
    //    아래 `Mui-selected` 의 `borderBottomColor: transparent` 와 같은 방식이다.
    ...(orientation !== "vertical" &&
        type !== "filled" && {
            "& .MuiTab-root:first-of-type": {
                borderLeftColor: `transparent`,
            },
        }),
    ...(orientation !== "vertical" &&
        divider && {
            ".MuiTab-root": {
                position: "relative",
                "&:not(:last-of-type)::after": {
                    content: '""',
                    position: "absolute",
                    right: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "50%",
                    borderRight: `1px solid ${theme.palette.greySecondary[100]}`,
                    marginLeft: "8px",
                },
            },
        }),
    ...(type === "filled" && {
        ".MuiTabs-indicator": {
            display: `none`,
        },
        ".MuiTab-root": {
            padding: `6.25px 16px`,
            backgroundColor: theme.palette.common.white,
            "&:first-of-type": {
                borderRadius: `3px 0 0 3px`,
            },
            "&:last-of-type": {
                borderRadius: `0 3px 3px 0`,
            },
            "&.Mui-selected ": {
                color: theme.palette.secondary.contrastText,
                backgroundColor: theme.palette.secondary.main,
                borderColor: theme.palette.secondary.main,
                "&:hover": {
                    color: theme.palette.secondary.contrastText,
                    backgroundColor: theme.palette.secondary.main,
                    borderColor: theme.palette.secondary.main,
                },
            },
        },
    }),
}));
